import { editorClient } from "@/lib/editorClient";
import { LanguageKey } from "@op/puck-types";

export async function getTopicPages(
  organizationSlug: string,
  projectSlug: string,
  languageKey: LanguageKey,
  topicSlug: string
) {
  const res = await editorClient.topics[":organizationSlug"][":projectSlug"][
    ":languageKey"
  ][":topicSlug"].pages.$get({
    param: {
      organizationSlug,
      projectSlug,
      languageKey,
      topicSlug,
    },
  });
  const data = await res.json();
  return data;
}
